module.exports = __webpack_public_path__ + "static/media/English - Teaching - Effort (nolyuk) - translated by JL.7036d780.txt";